import { AllCommentsProps } from "../../../../../data-model/busniessOfficeNote";
import SingleComment from "./singleComment";

const AllComments = (props: AllCommentsProps) => {
  return (
    <div className="all-comments-container mt-2 border-b border-dashed border-primaryGray-14 pb-4">
      <div className="all-comments-container--date mb-2 text-small font-bold">
        {props.commentDate}
      </div>
      <div className="all-comments-container--comments flex flex-col gap-4">
        {props.comments.map((comment, index) => (
          <SingleComment
            writeBackComment={comment.writeBackComment || ""}
            key={comment.id}
            showWriteBackNote={comment.showWriteBackNote}
            {...comment}
            onBoStatusChange={props.onBoStatusChange || (() => {})}
            onWriteBackCommentChange={
              props.onWriteBackCommentChange || (() => {})
            }
            boStatus={comment.boStatus || ""}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export default AllComments;
